import { useMemo } from 'react';
import { useAppContext } from '../../context/AppContext';
import { getBaseFilterConfig } from '../utils/BaseFilterConfig';
import { useFilterDefinitionsQuery } from './useFilterDefinitionsQuery';
export function useFilterConfig() {
  const {
    data
  } = useFilterDefinitionsQuery();
  const appContext = useAppContext();
  return useMemo(() => {
    const baseConfig = getBaseFilterConfig();
    const completeConfig = {};
    Object.entries(baseConfig).forEach(([key, filter]) => {
      var _filter$options2, _filter$optionGroups2;
      // Check if the filter is allowed for the current app context
      if (filter.allowedAppContext && filter.allowedAppContext !== appContext) return;

      // Falling back to empty arrays allows us to render the filter controls while loading.
      if (!data) {
        var _filter$options, _filter$optionGroups;
        completeConfig[key] = Object.assign({}, filter, {
          options: (_filter$options = filter.options) !== null && _filter$options !== void 0 ? _filter$options : [],
          optionGroups: (_filter$optionGroups = filter.optionGroups) !== null && _filter$optionGroups !== void 0 ? _filter$optionGroups : []
        });
        return;
      }
      const definition = getFilterDefinition(filter, data.result);
      completeConfig[key] = Object.assign({}, filter, {
        // If the base filter has hardcoded options, use them.
        // Otherwise, use the options from the RPC.
        options: (_filter$options2 = filter.options) !== null && _filter$options2 !== void 0 ? _filter$options2 : definition.options,
        optionGroups: (_filter$optionGroups2 = filter.optionGroups) !== null && _filter$optionGroups2 !== void 0 ? _filter$optionGroups2 : definition.optionGroups
      });
    });
    return completeConfig;
  }, [data, appContext]);
}
function getFilterDefinition(filter, result) {
  var _filter$productType;
  const definitions = filter.productType ? result.filtersByProductType[filter.productType] : result.universalFilters;
  const found = definitions === null || definitions === void 0 ? void 0 : definitions.find(f => f.baseQueryField === filter.field);
  if (!found) throw new Error(`${(_filter$productType = filter.productType) !== null && _filter$productType !== void 0 ? _filter$productType : 'UNIVERSAL'} filter not found: ${filter.field}`);
  return found;
}